import React from 'react'
import { Link } from 'react-router-dom'

import logo from '../../assets/logo.png'
import styles from './Navigation.module.scss'
import NavigationItem from './NavigationItem'

const Navigation = () => {
  return (
    <><nav className={styles.nav}>
      <div class={styles.container}>
      <input id="responsive-menu" type="checkbox" />
      <label for="responsive-menu"> <Link to="/">
          <img src={logo} alt="logo" className={styles.LogoImg} />
        </Link><span className={styles.menuicon}></span></label>
      <div id="overlay"></div>
      <ul>
            <li><a href="/list/2021/winter">winter 2021-2022</a></li>
            <li><a href="/list/2020/winter">winter 2020-2021</a></li>
            <li><a href="/list/2020/spring">spring 2020-2021</a></li>
            <li><a href="/list/2020/spring">spring 2020-2021</a></li>
            <li><a href="/list/2020/summer">summer 2020-2021</a></li>
            <li><a href="/list/2020/summer">summer 2020-2021</a></li>
            <li><a href="/list/2020/fall">fall 2020-2021</a></li>
            <li><a href="/list/2020/fall">fall 2020-2021</a></li>
        </ul>
      </div>
    </nav>
    
    <div className={styles.Navigation}>
      <div className={styles.Logo}>
        <Link to="/">
          <img src={logo} alt="logo" className={styles.LogoImg} />
        </Link>
      </div>
      <ul className={styles.NavigationItems}>
        {['winter', 'spring', 'summer', 'fall'].map(season => (
          <NavigationItem season={season} key={season} />
        ))}
      </ul>
    </div></>
  )
}

export default Navigation
